import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgScrollbarModule } from 'ngx-scrollbar';

import { NumpadModule } from '../../../lib/numpad/numpad.module';
import { ShareMyBetModule } from '../../../lib/share-my-bet/share-my-bet.module';
import BetslipBaseModule from '../../base/betslip-base.module';
import { BetslipDigitalCommonModule } from '../common/digital-module';
import NumpadContainerModule from '../numpad/numpad-container.module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import { QuickDepositModule } from '../quick-deposit/quick-deposit.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalTaxationModule from '../taxation/betslip-digital-taxation.module';
import BetslipDigitalTrackingModule from '../tracking/betslip-digital-tracking.module';
import WalletTypeContainerModule from '../wallet-type/wallet-type-container.module';
import { DigitalBalanceHeaderComponent } from './digital-balance-header.component';

@NgModule({
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipDigitalCommonModule,
        BetslipDigitalPicksModule,
        NumpadModule,
        BetslipDigitalTaxationModule,
        NgScrollbarModule,
        BetslipDigitalTrackingModule,
        ShareMyBetModule,
        QuickDepositModule,
        DigitalRewardTokensModule,
        BetslipDigitalSummaryModule,
        WalletTypeContainerModule,
        NumpadContainerModule,
    ],
    declarations: [DigitalBalanceHeaderComponent],
    exports: [DigitalBalanceHeaderComponent],
})
export class DigitalBalanceHeaderModule {}
